module.exports = __webpack_public_path__ + "img/icon_acc_tickets.8b545430.svg";